import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { useMarketParam } from '~/contexts/UrlParamsContext';
import { REQUESTS_SEARCH_CACHE } from '~/pages/RequestsPage';
import { RequestsPageUrl } from '~/pages/urls';

interface IErrorToAllRequests {
  maxTextWidth: number;
  children: React.ReactNode;
}

export const ErrorToAllRequests: React.FC<IErrorToAllRequests> = (props) => {
  const { maxTextWidth, children } = props;
  const market = useMarketParam();
  return (
    <Box
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        my: 'auto',
      }}
    >
      <Typography align="center" color="textPrimary" variant="h4" sx={{ maxWidth: `${maxTextWidth}px` }}>
        {children}
      </Typography>
      <Button
        sx={{ mt: 3 }}
        to={RequestsPageUrl.expand({ market, ...REQUESTS_SEARCH_CACHE })}
        component={RouterLink}
      >
        All Requests
      </Button>
    </Box>
  );
}
